import React from 'react';
import Lottie from 'react-lottie';
import loadingAnimation from 'assets/animations/loader_conlicitacao_lottie.json';

const LoaderPayment: React.FC = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="card-container h-100 d-flex">
      <div className="m-auto">
        <Lottie options={defaultOptions} style={{ width: '150px', margin: '0 auto' }} />
      </div>
    </div>
  );
};

export default LoaderPayment;
